import React from "react";

const LABELS = {
    new: "New",
    active: "Active",
    won: "Won",
    lost: "Lost",
    converted: "Converted",
};

const LeadStatusBadge = ({ status }) => (
    <span className={`crm-status-badge crm-status-badge--${status}`}>
        {LABELS[status] || status}
    </span>
);

export default LeadStatusBadge;
